import { ref } from 'vue';
import type { CountryType } from '../../types/country';

const countryData = ref<CountryType>();

export const getCountry = async (countryDataUrl) => {
  try {
    const response = await fetch(countryDataUrl);

    if (!response.ok) {
      throw new Error(`} >>> error, ${response.status}`);
    }

    // Fix to remove comma after last
    const rawText = await response.text();

    const sanitizedJson = rawText.replace(/,(\s*[}\]])/g, '$1').replace(/,(\s*$)/g, '');

    countryData.value = JSON.parse(sanitizedJson);

    return countryData.value;
  } catch (error) {
    console.error(error);
  }
};
